import articles from '~/data/generated/articles';
import { getMarketingUrl, getUrl } from '~/helpers/url';

const getArticlesByCategory = ({ path }) => {
  return articles.filter((a) => {
    if (a.hidden) {
      return false;
    }

    return a.category === path && a.path !== path;
  });
};

const getSortedArticlesByCategory = (article) => {
  return getArticlesByCategory(article)
    .sort(categoriesComparator);

  function categoriesComparator(a, b) {
    const { order: aOrder } = a;
    const { order: bOrder } = b;
    if (aOrder !== undefined && bOrder !== undefined) {
      if (aOrder > bOrder) {
        return 1;
      }

      if (aOrder < bOrder) {
        return -1;
      }
    } else if (aOrder !== undefined) {
      return -1;
    } else if (bOrder !== undefined) {
      return 1;
    }

    return a.title.localeCompare(b.title);
  }
};

const getArticleUrl = ({ path }) => {
  return getUrl(path);
};

const isArticleActive = (article, currentArticle) => {
  if (currentArticle.path === article.path) {
    return true;
  }

  if (currentArticle.category) {
    return currentArticle.category.startsWith(article.path);
  }

  return false;
};

const getArticle = (path) => {
  return articles.find((a) => a.path === path);
};

const getArticleBreadcrumb = (article) => {
  const parts = article.path
    .split('/')
    .filter(Boolean);

  return parts
    .map((part) => {
      const item = getArticle(`/${part}`);

      if (item) {
        return ({
          name: item.title,
          item: getMarketingUrl(item.path)
        });
      }

      return null;
    })
    .filter(Boolean);
};

export {
  getArticlesByCategory,
  getSortedArticlesByCategory,
  getArticle,
  getArticleUrl,
  isArticleActive,
  getArticleBreadcrumb
};
